import script from "./KeyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeyButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__